/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { string, bool, func, shape, oneOfType, instanceOf } from 'prop-types';
import classNames from 'clsx';

import styles from './hamburger.scss';

/**
 * This is the Hamburger component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class Hamburger extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    className: string,
    active: bool,
    onClick: func,
    innerRef: oneOfType([func, shape({ current: instanceOf(Element) })])
      .isRequired,
  };

  static defaultProps = {
    className: null,
    active: false,
    onClick: () => {},
  };

  /**
   * Render Hamburger.
   *
   * @return {Object}
   */
  render() {
    const { className, active, onClick, innerRef } = this.props;

    return (
      <button
        ref={innerRef}
        className={classNames(styles.wrapper, className, {
          [styles.active]: active,
        })}
        onClick={onClick}
      >
        <span />
      </button>
    );
  }
}
